import { initializeApp, FirebaseApp } from "firebase/app"
import { getDatabase, Database } from "firebase/database"
import { getStorage, FirebaseStorage } from "firebase/storage"
import { envConfig } from '@/config';

// Toggle this flag to switch between envConfig and process.env
const USE_ENV_CONFIG = true;

const config = USE_ENV_CONFIG
    ? {
	apiKey: envConfig.FIREBASE_API_KEY,
	authDomain: envConfig.FIREBASE_AUTH_DOMAIN,
	databaseURL: envConfig.FIREBASE_DATABASE_URL,
	projectId: envConfig.FIREBASE_PROJECT_ID,
	storageBucket: envConfig.FIREBASE_STORAGE_BUCKET,
	messagingSenderId: envConfig.FIREBASE_MESSAGING_SENDER_ID,
	appId: envConfig.FIREBASE_APP_ID,
	}
: {
	apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
	authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
	databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
	projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.VUE_APP_FIREBASE_APP_ID,
	};

// Validate that all required config values are present
const requiredConfigKeys = [
	"apiKey",
	"authDomain",
	"databaseURL",
	"projectId",
	"storageBucket",
	"messagingSenderId",
	"appId",
]

const missingKeys = requiredConfigKeys.filter(
	(key) => !config[key as keyof typeof config]
)

if (missingKeys.length > 0) {
	const source = USE_ENV_CONFIG ? 'envConfig' : 'process.env (VUE_APP_*)'
	throw new Error(
		`Missing required Firebase configuration keys (${missingKeys.join(", ")}) from ${source}. ` +
		`Please ensure your environment configuration provides these values (see src/config or your .env files).`
	)
}

export const app: FirebaseApp = initializeApp(config)
export const storage: FirebaseStorage = getStorage(app)
export const database: Database = getDatabase(app)

